export const TRANSLATION_KEYS = {
  title: 'jbp-thing-to-improve',

  tableColumns: {
    name: 'jbp-key-initiatives-name',
    description: 'jbp-key-initiatives-description',
    businessUnit: 'jbp-key-initiatives-business-unit',
    financialGoal: 'jbp-key-initiatives-goal',
    period: 'jbp-key-initiatives-period',
    owner: 'jbp-key-initiatives-owner',
    status: 'jbp-key-initiatives-focus-status',
  },
}
